var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 640",
    width: 640,
    height: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M306.67 536C306.67 527.2 306.67 456.8 306.67 448C306.67 440 312 434.67 320 434.67C328 434.67 333.33 440 333.33 448C333.33 456.8 333.33 527.2 333.33 536C333.33 542.67 328 549.33 320 549.33C312 549.33 306.67 544 306.67 536Z",
    id: "d2bJ7DctkL"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.33 590.67C377.33 590.67 372 585.33 372 577.33C372 569.33 377.33 564 385.33 564C408.8 564 596.53 564 620 564C628 564 633.33 569.33 633.33 577.33C633.33 585.33 628 590.67 620 590.67C573.07 590.67 408.8 590.67 385.33 590.67Z",
    id: "e4z1z7n5Zc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 590.67C12 590.67 6.67 585.33 6.67 577.33C6.67 569.33 12 564 20 564C43.73 564 233.6 564 257.33 564C265.33 564 270.67 569.33 270.67 577.33C270.67 585.33 264 590.67 257.33 590.67C209.87 590.67 43.73 590.67 20 590.67Z",
    id: "bMBXof3p"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.33 633.33C249.33 633.33 244 628 244 620C244 611.6 244 544.4 244 536C244 528 249.33 522.67 257.33 522.67C269.87 522.67 370.13 522.67 382.67 522.67C390.67 522.67 396 528 396 536C396 544.4 396 611.6 396 620C396 628 390.67 633.33 382.67 633.33C357.6 633.33 269.87 633.33 257.33 633.33ZM369.33 606.67L369.33 549.33L270.67 549.33L270.67 606.67L369.33 606.67Z",
    id: "a20jyH9XaZ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372 138.67C364 138.67 358.67 133.33 358.67 125.33C358.67 114.8 358.67 30.53 358.67 20C358.67 14.67 362.67 9.33 366.67 8C372 6.67 377.33 6.67 381.33 10.67C391.2 21.2 470.13 105.47 480 116C484 120 484 125.33 482.67 130.67C481.33 134.67 476 138.67 470.67 138.67C450.93 138.67 381.87 138.67 372 138.67ZM440 112L385.33 53.33L385.33 112L440 112Z",
    id: "e7cVfaO44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.33 460C161.33 460 156 454.67 156 446.67C156 404 156 62.67 156 20C156 12 161.33 6.67 169.33 6.67C189.6 6.67 351.73 6.67 372 6.67C376 6.67 378.67 8 381.33 10.67C391.2 21.2 470.13 105.47 480 116C482.67 118.67 484 121.33 484 125.33C484 157.6 484 415.73 484 448C484 454.67 478.67 460 470.67 460C410.4 460 199.47 460 169.33 460ZM457.33 433.33L457.33 130.67L366.67 33.33L182.67 33.33L182.67 433.33L457.33 433.33Z",
    id: "hPEi1Hjet"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.33 238.67C241.33 238.67 236 233.33 236 225.33C236 217.33 241.33 212 249.33 212C263.6 212 377.73 212 392 212C400 212 405.33 217.33 405.33 225.33C404 233.33 398.67 238.67 390.67 238.67C362.4 238.67 263.47 238.67 249.33 238.67Z",
    id: "j3MoI018td"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.33 309.33C241.33 309.33 236 304 236 296C236 288 241.33 282.67 249.33 282.67C263.6 282.67 377.73 282.67 392 282.67C400 282.67 405.33 288 405.33 296C404 302.67 398.67 309.33 390.67 309.33C362.4 309.33 263.47 309.33 249.33 309.33Z",
    id: "i26ce7pOh"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.33 378.67C241.33 378.67 236 373.33 236 365.33C236 357.33 241.33 352 249.33 352C263.6 352 377.73 352 392 352C400 352 405.33 357.33 405.33 365.33C404 373.33 398.67 378.67 390.67 378.67C362.4 378.67 263.47 378.67 249.33 378.67Z",
    id: "b6NDYDsBI"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d2bJ7DctkL",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d2bJ7DctkL",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e4z1z7n5Zc",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e4z1z7n5Zc",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bMBXof3p",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bMBXof3p",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a20jyH9XaZ",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a20jyH9XaZ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e7cVfaO44",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e7cVfaO44",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hPEi1Hjet",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hPEi1Hjet",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j3MoI018td",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j3MoI018td",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i26ce7pOh",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i26ce7pOh",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b6NDYDsBI",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b6NDYDsBI",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon5);
export default __webpack_public_path__ + "static/media/info-icon-5.c6abf7967a83c6592c477461bcf8aa19.svg";
export { ForwardRef as ReactComponent };